import { render, staticRenderFns } from "./CallRatingsTable.vue?vue&type=template&id=3b344f28"
import script from "./CallRatingsTable.vue?vue&type=script&lang=js"
export * from "./CallRatingsTable.vue?vue&type=script&lang=js"
import style0 from "./CallRatingsTable.vue?vue&type=style&index=0&id=3b344f28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports